import * as React from "react";
import Api from "./Api";
import "./ShowMsgFile.scss";
import { Extensions } from "content-type-to-ext";
import { MSGReader, MSGErrorResult, MSGFileData } from "wl-msg-reader";
import { Document } from "@testout/testout-commerce/models/commerce/Document";

interface ShowMsgFileProps {
    quoteDocumentId?: string;
    orderDocumentId?: string;
}

interface ShowMsgFileState {
    from?: string;
    to?: string;
    date?: string;
    subject?: string;
    body?: string;
    attachments?: File[];
}

export default class ShowMsgFile extends React.PureComponent<ShowMsgFileProps, ShowMsgFileState> {
    constructor(props: ShowMsgFileProps) {
        super(props);
        this.state = { };
    }

    downloadDoc = (document: File) => {
        //if (doc.fileContent.type.includes('outlook')) {
        //    window.open('/showMsg?documentId=' + doc.documentId);
        //    return;
        //}
        const fileURL = URL.createObjectURL(document);
        window.open(fileURL);
    }

    async componentDidMount() {
        try {
            // Load the document file
            var document: Document;

            if (this.props.quoteDocumentId) {
                document = await Api.get<Document>(`/api/quotes/attachment/${this.props.quoteDocumentId}`);
            } else if (this.props.orderDocumentId) {
                document = await Api.get<Document>(`/api/orders/attachment/${this.props.orderDocumentId}`);
            } else
                return;

            document = new Document(document);
            if (!document.content) {
                this.setState({ subject: "The .msg file was empty" });
                return;
            }

            // Display the msg in the document
            let msgReader = new MSGReader(document.content.buffer);
            let fileData = msgReader.getFileData();
            if ((fileData as MSGErrorResult).error) {
                this.setState({ subject: "Unable to read the .msg file: " + (fileData as MSGErrorResult).error });
                return;
            }
            let data = fileData as MSGFileData;

            // Parse the recipients of the email
            let recipients = "";
            data.recipients.forEach(r => {
                if (recipients !== "")
                    recipients += ", ";
                recipients += `${r.name} <${r.email}>`;
            });

            // Parse the header for the date of the email
            let date = "";
            if (data.headers) {
                const headerRegEx = /(.*): (.*)/g;
                while (true) {
                    let m = headerRegEx.exec(data.headers);
                    if (!m)
                        break;
                    if (m[1] === 'Date') {
                        date = m[2];
                        break;
                    }
                }
            }

            // Get the attachment data
            let attachments = new Array<File>();
            data.attachments.forEach(a => {
                var file = msgReader.getAttachment(a);
                var ext = file.fileName.split('.').pop() ?? "jpg";
                var extType = ext as keyof typeof Extensions;
                var type = Extensions[extType];
                attachments.push(new File([file.content], file.fileName, { type: type }));
            });

            // Set the fields to display
            this.setState({
                subject: data.subject,
                from: `${data.senderName} <${data.senderEmail}>`,
                to: recipients,
                date: date,
                body: data.body,
                attachments: attachments
            });
        }
        catch (error: any) {
            this.setState({ subject: `Error while loading the attachment file: ${error.message}` });
        }
    }

    render() {
        let lines = (this.state?.body ?? "").split("\r\n");
        return <div className="msgBody">
            <h2>{this.state.subject}</h2>
            <div className="msgFloatRight">{this.state.date}</div>
            <h3>From: {this.state.from}</h3>
            <div className="toLine">To: {this.state.to}</div>
            {this.state.attachments && this.state.attachments.length > 0 && this.state.attachments.filter(a => a.size > 64).map(a => <div>
                <div className="msgAttachment">{a.name} ({a.size} bytes) <button className="followLink" onClick={() => this.downloadDoc(a)}>&nbsp;</button></div>
            </div>)}
            <div className="message">
                {lines.map((line: string) => (<p>{line}&nbsp;</p>))}
            </div>
        </div>;
    }
}